import React from 'react';
import { mockData } from '../data/mockData';
import * as Icons from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-32 bg-black">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="display-large text-white mb-6">
            What is a <span className="text-[#00FFD1]">360° Virtual Tour?</span>
          </h2>
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            A 360° Virtual Tour is an immersive, interactive experience that allows viewers to 
            explore your physical space remotely. Using high-resolution panoramic photography, 
            customers can navigate through your location as if they were physically present.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {mockData.benefits.map((benefit, index) => {
            const IconComponent = Icons[benefit.icon];
            return (
              <div
                key={index}
                className="group p-8 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00FFD1]/50 hover:bg-white/10 transition-all duration-400"
              >
                <div className="w-16 h-16 mb-6 bg-[#00FFD1]/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-400">
                  <IconComponent className="w-8 h-8 text-[#00FFD1]" />
                </div>
                <h3 className="heading-3 text-white mb-4">{benefit.title}</h3>
                <p className="body-medium text-white/70">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
